import { render, staticRenderFns } from "./InfoMediaAvailableList.vue?vue&type=template&id=36d81e6c&scoped=true"
import script from "./InfoMediaAvailableList.vue?vue&type=script&lang=js"
export * from "./InfoMediaAvailableList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d81e6c",
  null
  
)

export default component.exports